import script from './ToastNotification.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast-notification"},[_c('Icon',{class:_vm.iconClass}),_vm._v(" "),(_vm.showWhiteBackground)?_c('div',{staticClass:"white-circle-background"}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.text)+"\n")],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-2c1d0320_0", { source: ".toast-notification[data-v-2c1d0320]{background-color:#3d3d3d;color:#fff;padding:10px 20px 10px 10px;box-shadow:0 2px 10px rgba(0,0,0,.3);border-radius:6px;display:flex;gap:8px;align-items:center;width:fit-content;font-weight:400;font-size:13px;line-height:15px;position:relative}.white-circle-background[data-v-2c1d0320]{height:14px;width:14px;background-color:#fff;border-radius:50%;position:absolute;z-index:1;left:13px}.icon[data-v-2c1d0320]{z-index:2;font-size:20px;width:20px;height:20px}.icon-close_circle_filled[data-v-2c1d0320]{color:#a31c1c}.icon-check_circle_filled[data-v-2c1d0320]{color:#258a54}.icon-warning_triangle_filled[data-v-2c1d0320]{color:#f5a623}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-2c1d0320";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
